if (!customElements.get('product-options')) {
  class ProductOptionPicker extends HTMLElement {
    constructor() {
      super();

      this.section = this.closest('.main-product');
      this.productOptions = this.querySelectorAll('ul');
      this.productOptionsList = this.querySelectorAll('li');
      this.productDropdowns = this.querySelectorAll('.product-option-picker__dropdown');

      this.sectionId = this.section.dataset.sectionId;
      this.productUrl = this.dataset.productUrl;

      for (let dropdown of this.productDropdowns) {
        dropdown.addEventListener('click', (event) => {
          this.dropdown(dropdown, event);
        });

        document.addEventListener('click', (event) => {
          if (event.target !== dropdown && !dropdown.contains(event.target)) {
            this.closeDropdown(dropdown);
          }
        });
      }

      document.body.addEventListener('click', (event) => {
        var option = event.target.closest('.product-option-picker__list-item');
        if (option && !option.classList.contains('disabled') && !option.classList.contains('chosen')) {
          this.onClick(option);
        }
      });

      for (let productOption of this.productOptionsList) {
        productOption.addEventListener('focus', () => {
          productOption.addEventListener('keyup', (event) => {
            if (event.key === 'Enter') {
              productOption.click();
            }
          });
        });
      }
    }

    onClick(option) {
      this.selectionPicker(option);

      this.productOptions = option.closest('product-options').querySelectorAll('ul');

      var optionProductUrl = option.querySelector('input').dataset.productUrl;

      var chosenOptionValues = '';
      this.productOptions.forEach((list) => {
        for (let list_item of list.children) {
          if (list_item.classList.contains('chosen')) {
            var chosenOptionId = list_item.querySelector('input').dataset.id;
            chosenOptionValues = chosenOptionValues + chosenOptionId + ',';
          }
        }
      });
      chosenOptionValues = chosenOptionValues.slice(0, -1);

      var url = optionProductUrl + '?section_id=' + this.sectionId + '&option_values=' + chosenOptionValues;

      fetch(url)
        .then((res) => res.text())
        .then((response) => {
          var parsed_response = new DOMParser().parseFromString(response, 'text/html');
          var variantIdEl = parsed_response.querySelector('input[name="id"]');
          var variantId = variantIdEl ? variantIdEl.value : null;

          if (!variantId) return;

          let newUrl;

          if (this.productUrl !== optionProductUrl) {
            const newMainProduct = parsed_response.querySelector('.main-product');
            if (newMainProduct) {
              this.section.innerHTML = newMainProduct.innerHTML;
            }

            this.productUrl = optionProductUrl;
            newUrl = new URL(window.location.origin + optionProductUrl);
          } else {
            var product_options = parsed_response.querySelector('product-options');
            var product_summary__product_form = parsed_response.querySelector('.product-summary__product-form');
            var pickup_availability = parsed_response.querySelector('pickup-availability');

            const livePickup = this.section.querySelector('pickup-availability');
            const liveFormWrap = this.section.querySelector('.product-summary__product-form');
            const liveOptions = this.section.querySelector('product-options');

            if (livePickup && pickup_availability) livePickup.innerHTML = pickup_availability.innerHTML;
            if (liveFormWrap && product_summary__product_form) liveFormWrap.innerHTML = product_summary__product_form.innerHTML;
            if (liveOptions && product_options) liveOptions.innerHTML = product_options.innerHTML;

            newUrl = new URL(window.location.href);
          }

          if (newUrl.searchParams.get('variant') !== null) {
            newUrl.searchParams.set('variant', variantId);
          } else {
            newUrl.searchParams.append('variant', variantId);
          }

          const liveForm = this.section.querySelector('form[action*="/cart/add"]');
          if (liveForm) {
            const idInput = liveForm.querySelector('input[name="id"]');
            if (idInput) idInput.value = variantId;

            liveForm.dispatchEvent(
              new CustomEvent('variant:change', {
                bubbles: true,
                detail: { variantId: variantId },
              })
            );

            liveForm.dispatchEvent(new Event('change', { bubbles: true }));
          }

          if (!Shopify.designMode) {
            history.pushState({}, null, newUrl);
          }
        })
        .catch((error) => {
          throw error;
        });
    }

    selectionPicker(option) {
      var currentDropdown = option.parentElement;
      var currentDropdownListItems = currentDropdown.querySelectorAll('li');
      var chosenElements = currentDropdown.parentElement.parentElement.querySelectorAll(
        '.product-option-picker-chosen > span, .product-option-picker-label > .product-option-picker-label--chosen'
      );
      var chosenSwatchElement = currentDropdown.parentElement.parentElement.querySelector(
        '.product-option-picker-chosen > .product-option-swatch'
      );
      var chosenOptionSwatch = option.querySelector('.product-option-swatch');

      for (let item of currentDropdownListItems) {
        item.classList.remove('chosen');
      }
      option.classList.add('chosen');

      for (let chosen of chosenElements) {
        chosen.innerText = option.textContent.trim();
      }

      if (chosenOptionSwatch) {
        var optionProductSwatchStyles = getComputedStyle(chosenOptionSwatch);
        var optionSwatchColor = optionProductSwatchStyles.getPropertyValue('--product-swatch-value');
        if (optionSwatchColor.length == 0) {
          optionSwatchColor = option.dataset.optionValue;
        }
        if (chosenSwatchElement) {
          chosenSwatchElement.innerHTML = chosenOptionSwatch.innerHTML;
          chosenSwatchElement.style.setProperty('--product-swatch-value', optionSwatchColor);
        }
      }
    }

    dropdown(dropdown, event) {
      if (dropdown.classList.contains('active')) {
        this.closeDropdown(dropdown);
        dropdown.blur();
      } else {
        if (!dropdown.matches(':focus-within:not(:focus)')) {
          this.openDropdown(dropdown);
        }
      }
    }

    openDropdown(dropdown) {
      dropdown.classList.add('active');
    }
    closeDropdown(dropdown) {
      dropdown.classList.remove('active');
    }
  }

  customElements.define('product-options', ProductOptionPicker);
}